import React from 'react'
import './Token.scss'
import TokenBox from './tokenbox/TokenBox'
// import crown from '../../assets/crown.png'
// import { Button } from '../button/Button'

const Token = ({onClick,onClick2,onClick3,onClick4}) => {
    
    return (
        <>
            <div className="token__container">
                <div className="token__container-wrap">
                    <div className="token__container-wrap-carousel">
                        <div className="token__box">
                            <TokenBox header="SOLO" competitionType1="LEAGUE" competitionType2="Challange" onClick={onClick} onClick2={onClick2}/>
                        </div>

                        <div className="token__box">
                            <TokenBox header="TEAM" competitionType1="Round of 8" competitionType2="LEAGUE" onClick={onClick3} onClick2={onClick4}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Token
